// extracted by mini-css-extract-plugin
export var downArrow = "_9y-0";
export var label = "_9y-1";
export var treatmentCard = "_9y-3";
export var upArrow = "_9y-2";